/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiCanActivateCampaignResponseFromJSON, ApiComponentAIBlockEditorPayloadToJSON, ApiComponentBlockFromJSON, ApiCreateUpdateCampaignPayloadToJSON, ApiCreateUpdateComponentPayloadToJSON, ApiCreateUpdatePersonalisationPayloadToJSON, ApiListCampaignsResponseFromJSON, ApiListComponentsResponseFromJSON, ApiListPersonalisationsResponseFromJSON, ApiReadCampaignResponseFromJSON, ApiReadComponentResponseFromJSON, ApiReadPersonalisationResponseFromJSON, InlineObject6ToJSON, InlineObject7ToJSON, InlineObject8ToJSON, } from '../models';
/**
 *
 */
export class PersonalisationServiceApi extends runtime.BaseAPI {
    /**
     */
    personalisationServiceActivateCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceActivateCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceActivateCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}/activate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceActivateCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceActivateCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceBatchGenerateComponentsFromAdsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceBatchGenerateComponentsFromAds.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling personalisationServiceBatchGenerateComponentsFromAds.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/batch-generate-from-ads`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject6ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    personalisationServiceBatchGenerateComponentsFromAds(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceBatchGenerateComponentsFromAdsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceCanActivateCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceCanActivateCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceCanActivateCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}/can-activate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiCanActivateCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceCanActivateCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceCanActivateCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceComponentAIBlockEditorRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceComponentAIBlockEditor.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceComponentAIBlockEditor.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/component-ai-block-editor`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiComponentAIBlockEditorPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiComponentBlockFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceComponentAIBlockEditor(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceComponentAIBlockEditorRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceCreateCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceCreateCampaign.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceCreateCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.campaignId !== undefined) {
                queryParameters['campaignId'] = requestParameters.campaignId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateCampaignPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceCreateCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceCreateCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceCreateComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceCreateComponent.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceCreateComponent.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateComponentPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceCreateComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceCreateComponentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceCreatePersonalisationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceCreatePersonalisation.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceCreatePersonalisation.');
            }
            const queryParameters = {};
            if (requestParameters.personalisationId !== undefined) {
                queryParameters['personalisationId'] = requestParameters.personalisationId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/personalisations`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdatePersonalisationPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadPersonalisationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceCreatePersonalisation(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceCreatePersonalisationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceCreateSharedComponentBlockRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceCreateSharedComponentBlock.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/shared-component-blocks`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateComponentPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceCreateSharedComponentBlock(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceCreateSharedComponentBlockRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceDeactivateCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceDeactivateCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceDeactivateCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}/deactivate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceDeactivateCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceDeactivateCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceDeleteCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceDeleteCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceDeleteCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    personalisationServiceDeleteCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceDeleteCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceDeleteComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceDeleteComponent.');
            }
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceDeleteComponent.');
            }
            const queryParameters = {};
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/{componentId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    personalisationServiceDeleteComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceDeleteComponentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceDeletePersonalisationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceDeletePersonalisation.');
            }
            if (requestParameters.personalisationId === null || requestParameters.personalisationId === undefined) {
                throw new runtime.RequiredError('personalisationId', 'Required parameter requestParameters.personalisationId was null or undefined when calling personalisationServiceDeletePersonalisation.');
            }
            const queryParameters = {};
            if (requestParameters.payloadLocationId !== undefined) {
                queryParameters['payload.locationId'] = requestParameters.payloadLocationId;
            }
            if (requestParameters.payloadAppliedTo !== undefined) {
                queryParameters['payload.appliedTo'] = requestParameters.payloadAppliedTo;
            }
            if (requestParameters.payloadInsertionType !== undefined) {
                queryParameters['payload.insertionType'] = requestParameters.payloadInsertionType;
            }
            if (requestParameters.payloadCampaignId !== undefined) {
                queryParameters['payload.campaignId'] = requestParameters.payloadCampaignId;
            }
            if (requestParameters.payloadComponentId !== undefined) {
                queryParameters['payload.componentId'] = requestParameters.payloadComponentId;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/personalisations/{personalisationId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"personalisationId"}}`, encodeURIComponent(String(requestParameters.personalisationId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    personalisationServiceDeletePersonalisation(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceDeletePersonalisationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceDeleteSharedComponentBlockRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceDeleteSharedComponentBlock.');
            }
            const queryParameters = {};
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/shared-component-blocks/{componentId}`.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    personalisationServiceDeleteSharedComponentBlock(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceDeleteSharedComponentBlockRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceGenerateComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceGenerateComponent.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling personalisationServiceGenerateComponent.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/generate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject7ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceGenerateComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceGenerateComponentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * ------------- Campaigns ----------------
     */
    personalisationServiceListCampaignsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListCampaigns.');
            }
            const queryParameters = {};
            if (requestParameters.campaignId !== undefined) {
                queryParameters['campaignId'] = requestParameters.campaignId;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListCampaignsResponseFromJSON(jsonValue));
        });
    }
    /**
     * ------------- Campaigns ----------------
     */
    personalisationServiceListCampaigns(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListCampaignsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * ------------- Components ----------------
     */
    personalisationServiceListComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListComponents.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     * ------------- Components ----------------
     */
    personalisationServiceListComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceListLanderBlockComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListLanderBlockComponents.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components:lander-blocks`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceListLanderBlockComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListLanderBlockComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceListLanderComponentComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListLanderComponentComponents.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components:lander-components`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceListLanderComponentComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListLanderComponentComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceListLanderComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListLanderComponents.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components:landers`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceListLanderComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListLanderComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceListLanderTemplateComponentsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListLanderTemplateComponents.');
            }
            const queryParameters = {};
            if (requestParameters.componentId !== undefined) {
                queryParameters['componentId'] = requestParameters.componentId;
            }
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components:lander-templates`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceListLanderTemplateComponents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListLanderTemplateComponentsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * ------------- Personalisations ----------------
     */
    personalisationServiceListPersonalisationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceListPersonalisations.');
            }
            const queryParameters = {};
            if (requestParameters.personalisationId !== undefined) {
                queryParameters['personalisationId'] = requestParameters.personalisationId;
            }
            if (requestParameters.payloadLocationId !== undefined) {
                queryParameters['payload.locationId'] = requestParameters.payloadLocationId;
            }
            if (requestParameters.payloadAppliedTo !== undefined) {
                queryParameters['payload.appliedTo'] = requestParameters.payloadAppliedTo;
            }
            if (requestParameters.payloadInsertionType !== undefined) {
                queryParameters['payload.insertionType'] = requestParameters.payloadInsertionType;
            }
            if (requestParameters.payloadCampaignId !== undefined) {
                queryParameters['payload.campaignId'] = requestParameters.payloadCampaignId;
            }
            if (requestParameters.payloadComponentId !== undefined) {
                queryParameters['payload.componentId'] = requestParameters.payloadComponentId;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/personalisations`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListPersonalisationsResponseFromJSON(jsonValue));
        });
    }
    /**
     * ------------- Personalisations ----------------
     */
    personalisationServiceListPersonalisations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListPersonalisationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * ------------- Shared Component Blocks ---------------- these are blocks in middle earth.
     */
    personalisationServiceListSharedComponentBlocksRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/shared-component-blocks`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListComponentsResponseFromJSON(jsonValue));
        });
    }
    /**
     * ------------- Shared Component Blocks ---------------- these are blocks in middle earth.
     */
    personalisationServiceListSharedComponentBlocks(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceListSharedComponentBlocksRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * helper method to avoid full minification of component
     */
    personalisationServicePatchComponentThemeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServicePatchComponentTheme.');
            }
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServicePatchComponentTheme.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling personalisationServicePatchComponentTheme.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/{componentId}/theme`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: InlineObject8ToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     * helper method to avoid full minification of component
     */
    personalisationServicePatchComponentTheme(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServicePatchComponentThemeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceReadCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceReadCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceReadCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadStartDate !== undefined) {
                queryParameters['payload.startDate'] = requestParameters.payloadStartDate.toISOString();
            }
            if (requestParameters.payloadEndDate !== undefined) {
                queryParameters['payload.endDate'] = requestParameters.payloadEndDate.toISOString();
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadMaxNumberOfLeads !== undefined) {
                queryParameters['payload.maxNumberOfLeads'] = requestParameters.payloadMaxNumberOfLeads;
            }
            if (requestParameters.payloadProbability !== undefined) {
                queryParameters['payload.probability'] = requestParameters.payloadProbability;
            }
            if (requestParameters.payloadAudienceIds) {
                queryParameters['payload.audienceIds'] = requestParameters.payloadAudienceIds;
            }
            if (requestParameters.payloadSubdomainId !== undefined) {
                queryParameters['payload.subdomainId'] = requestParameters.payloadSubdomainId;
            }
            if (requestParameters.payloadUrls) {
                queryParameters['payload.urls'] = requestParameters.payloadUrls;
            }
            if (requestParameters.payloadFallbackUrl !== undefined) {
                queryParameters['payload.fallbackUrl'] = requestParameters.payloadFallbackUrl;
            }
            if (requestParameters.payloadNoCache !== undefined) {
                queryParameters['payload.noCache'] = requestParameters.payloadNoCache;
            }
            if (requestParameters.payloadClassificationItemIds) {
                queryParameters['payload.classificationItemIds'] = requestParameters.payloadClassificationItemIds;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceReadCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceReadCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceReadComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceReadComponent.');
            }
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceReadComponent.');
            }
            const queryParameters = {};
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/{componentId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceReadComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceReadComponentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceReadPersonalisationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceReadPersonalisation.');
            }
            if (requestParameters.personalisationId === null || requestParameters.personalisationId === undefined) {
                throw new runtime.RequiredError('personalisationId', 'Required parameter requestParameters.personalisationId was null or undefined when calling personalisationServiceReadPersonalisation.');
            }
            const queryParameters = {};
            if (requestParameters.payloadLocationId !== undefined) {
                queryParameters['payload.locationId'] = requestParameters.payloadLocationId;
            }
            if (requestParameters.payloadAppliedTo !== undefined) {
                queryParameters['payload.appliedTo'] = requestParameters.payloadAppliedTo;
            }
            if (requestParameters.payloadInsertionType !== undefined) {
                queryParameters['payload.insertionType'] = requestParameters.payloadInsertionType;
            }
            if (requestParameters.payloadCampaignId !== undefined) {
                queryParameters['payload.campaignId'] = requestParameters.payloadCampaignId;
            }
            if (requestParameters.payloadComponentId !== undefined) {
                queryParameters['payload.componentId'] = requestParameters.payloadComponentId;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/personalisations/{personalisationId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"personalisationId"}}`, encodeURIComponent(String(requestParameters.personalisationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadPersonalisationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceReadPersonalisation(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceReadPersonalisationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceReadSharedComponentBlockRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceReadSharedComponentBlock.');
            }
            const queryParameters = {};
            if (requestParameters.payloadHtml !== undefined) {
                queryParameters['payload.html'] = requestParameters.payloadHtml;
            }
            if (requestParameters.payloadCss !== undefined) {
                queryParameters['payload.css'] = requestParameters.payloadCss;
            }
            if (requestParameters.payloadJs !== undefined) {
                queryParameters['payload.js'] = requestParameters.payloadJs;
            }
            if (requestParameters.payloadName !== undefined) {
                queryParameters['payload.name'] = requestParameters.payloadName;
            }
            if (requestParameters.payloadDescription !== undefined) {
                queryParameters['payload.description'] = requestParameters.payloadDescription;
            }
            if (requestParameters.payloadGrapeJs !== undefined) {
                queryParameters['payload.grapeJs'] = requestParameters.payloadGrapeJs;
            }
            if (requestParameters.payloadUiSource !== undefined) {
                queryParameters['payload.uiSource'] = requestParameters.payloadUiSource;
            }
            if (requestParameters.payloadHead !== undefined) {
                queryParameters['payload.head'] = requestParameters.payloadHead;
            }
            if (requestParameters.payloadSeoTitle !== undefined) {
                queryParameters['payload.seoTitle'] = requestParameters.payloadSeoTitle;
            }
            if (requestParameters.payloadSeoDescrition !== undefined) {
                queryParameters['payload.seoDescrition'] = requestParameters.payloadSeoDescrition;
            }
            if (requestParameters.payloadFavicon !== undefined) {
                queryParameters['payload.favicon'] = requestParameters.payloadFavicon;
            }
            if (requestParameters.payloadType !== undefined) {
                queryParameters['payload.type'] = requestParameters.payloadType;
            }
            if (requestParameters.payloadTheme !== undefined) {
                queryParameters['payload.theme'] = requestParameters.payloadTheme;
            }
            if (requestParameters.payloadAiHtml !== undefined) {
                queryParameters['payload.aiHtml'] = requestParameters.payloadAiHtml;
            }
            if (requestParameters.payloadAiCss !== undefined) {
                queryParameters['payload.aiCss'] = requestParameters.payloadAiCss;
            }
            if (requestParameters.payloadAiJs !== undefined) {
                queryParameters['payload.aiJs'] = requestParameters.payloadAiJs;
            }
            if (requestParameters.payloadCategory !== undefined) {
                queryParameters['payload.category'] = requestParameters.payloadCategory;
            }
            if (requestParameters.payloadPromptId !== undefined) {
                queryParameters['payload.promptId'] = requestParameters.payloadPromptId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/personalisation/v1/shared-component-blocks/{componentId}`.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceReadSharedComponentBlock(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceReadSharedComponentBlockRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceUpdateCampaignRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceUpdateCampaign.');
            }
            if (requestParameters.campaignId === null || requestParameters.campaignId === undefined) {
                throw new runtime.RequiredError('campaignId', 'Required parameter requestParameters.campaignId was null or undefined when calling personalisationServiceUpdateCampaign.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceUpdateCampaign.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/campaigns/{campaignId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters.campaignId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateCampaignPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadCampaignResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceUpdateCampaign(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceUpdateCampaignRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceUpdateComponentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceUpdateComponent.');
            }
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceUpdateComponent.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceUpdateComponent.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/components/{componentId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateComponentPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceUpdateComponent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceUpdateComponentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceUpdatePersonalisationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.projectId === null || requestParameters.projectId === undefined) {
                throw new runtime.RequiredError('projectId', 'Required parameter requestParameters.projectId was null or undefined when calling personalisationServiceUpdatePersonalisation.');
            }
            if (requestParameters.personalisationId === null || requestParameters.personalisationId === undefined) {
                throw new runtime.RequiredError('personalisationId', 'Required parameter requestParameters.personalisationId was null or undefined when calling personalisationServiceUpdatePersonalisation.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceUpdatePersonalisation.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/projects/{projectId}/personalisations/{personalisationId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters.projectId))).replace(`{${"personalisationId"}}`, encodeURIComponent(String(requestParameters.personalisationId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdatePersonalisationPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadPersonalisationResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceUpdatePersonalisation(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceUpdatePersonalisationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    personalisationServiceUpdateSharedComponentBlockRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.componentId === null || requestParameters.componentId === undefined) {
                throw new runtime.RequiredError('componentId', 'Required parameter requestParameters.componentId was null or undefined when calling personalisationServiceUpdateSharedComponentBlock.');
            }
            if (requestParameters.payload === null || requestParameters.payload === undefined) {
                throw new runtime.RequiredError('payload', 'Required parameter requestParameters.payload was null or undefined when calling personalisationServiceUpdateSharedComponentBlock.');
            }
            const queryParameters = {};
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/personalisation/v1/shared-component-blocks/{componentId}`.replace(`{${"componentId"}}`, encodeURIComponent(String(requestParameters.componentId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: ApiCreateUpdateComponentPayloadToJSON(requestParameters.payload),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiReadComponentResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    personalisationServiceUpdateSharedComponentBlock(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.personalisationServiceUpdateSharedComponentBlockRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceActivateCampaignPayloadTypeEnum;
(function (PersonalisationServiceActivateCampaignPayloadTypeEnum) {
    PersonalisationServiceActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceActivateCampaignPayloadTypeEnum || (PersonalisationServiceActivateCampaignPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceCanActivateCampaignPayloadTypeEnum;
(function (PersonalisationServiceCanActivateCampaignPayloadTypeEnum) {
    PersonalisationServiceCanActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceCanActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceCanActivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceCanActivateCampaignPayloadTypeEnum || (PersonalisationServiceCanActivateCampaignPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeactivateCampaignPayloadTypeEnum;
(function (PersonalisationServiceDeactivateCampaignPayloadTypeEnum) {
    PersonalisationServiceDeactivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceDeactivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceDeactivateCampaignPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceDeactivateCampaignPayloadTypeEnum || (PersonalisationServiceDeactivateCampaignPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteCampaignPayloadTypeEnum;
(function (PersonalisationServiceDeleteCampaignPayloadTypeEnum) {
    PersonalisationServiceDeleteCampaignPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceDeleteCampaignPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceDeleteCampaignPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceDeleteCampaignPayloadTypeEnum || (PersonalisationServiceDeleteCampaignPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteComponentPayloadUiSourceEnum;
(function (PersonalisationServiceDeleteComponentPayloadUiSourceEnum) {
    PersonalisationServiceDeleteComponentPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceDeleteComponentPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceDeleteComponentPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceDeleteComponentPayloadUiSourceEnum || (PersonalisationServiceDeleteComponentPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteComponentPayloadTypeEnum;
(function (PersonalisationServiceDeleteComponentPayloadTypeEnum) {
    PersonalisationServiceDeleteComponentPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceDeleteComponentPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceDeleteComponentPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceDeleteComponentPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceDeleteComponentPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceDeleteComponentPayloadTypeEnum || (PersonalisationServiceDeleteComponentPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteComponentPayloadCategoryEnum;
(function (PersonalisationServiceDeleteComponentPayloadCategoryEnum) {
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceDeleteComponentPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceDeleteComponentPayloadCategoryEnum || (PersonalisationServiceDeleteComponentPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum;
(function (PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum) {
    PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum["IT_UNSPECIFIED"] = "IT_UNSPECIFIED";
    PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum["APPEND"] = "APPEND";
    PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum["PREPEND"] = "PREPEND";
    PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum["REPLACE"] = "REPLACE";
})(PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum || (PersonalisationServiceDeletePersonalisationPayloadInsertionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum;
(function (PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum) {
    PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum || (PersonalisationServiceDeleteSharedComponentBlockPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum;
(function (PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum) {
    PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum || (PersonalisationServiceDeleteSharedComponentBlockPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum;
(function (PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum) {
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum || (PersonalisationServiceDeleteSharedComponentBlockPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListCampaignsPayloadTypeEnum;
(function (PersonalisationServiceListCampaignsPayloadTypeEnum) {
    PersonalisationServiceListCampaignsPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceListCampaignsPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceListCampaignsPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceListCampaignsPayloadTypeEnum || (PersonalisationServiceListCampaignsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListComponentsPayloadUiSourceEnum;
(function (PersonalisationServiceListComponentsPayloadUiSourceEnum) {
    PersonalisationServiceListComponentsPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceListComponentsPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceListComponentsPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceListComponentsPayloadUiSourceEnum || (PersonalisationServiceListComponentsPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListComponentsPayloadTypeEnum;
(function (PersonalisationServiceListComponentsPayloadTypeEnum) {
    PersonalisationServiceListComponentsPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceListComponentsPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceListComponentsPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceListComponentsPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceListComponentsPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceListComponentsPayloadTypeEnum || (PersonalisationServiceListComponentsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListComponentsPayloadCategoryEnum;
(function (PersonalisationServiceListComponentsPayloadCategoryEnum) {
    PersonalisationServiceListComponentsPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceListComponentsPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceListComponentsPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceListComponentsPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceListComponentsPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceListComponentsPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceListComponentsPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceListComponentsPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceListComponentsPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceListComponentsPayloadCategoryEnum || (PersonalisationServiceListComponentsPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum;
(function (PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum) {
    PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum || (PersonalisationServiceListLanderBlockComponentsPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum;
(function (PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum) {
    PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum || (PersonalisationServiceListLanderBlockComponentsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum;
(function (PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum) {
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum || (PersonalisationServiceListLanderBlockComponentsPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum;
(function (PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum) {
    PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum || (PersonalisationServiceListLanderComponentComponentsPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum;
(function (PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum) {
    PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum || (PersonalisationServiceListLanderComponentComponentsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum;
(function (PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum) {
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum || (PersonalisationServiceListLanderComponentComponentsPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentsPayloadUiSourceEnum;
(function (PersonalisationServiceListLanderComponentsPayloadUiSourceEnum) {
    PersonalisationServiceListLanderComponentsPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceListLanderComponentsPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceListLanderComponentsPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceListLanderComponentsPayloadUiSourceEnum || (PersonalisationServiceListLanderComponentsPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentsPayloadTypeEnum;
(function (PersonalisationServiceListLanderComponentsPayloadTypeEnum) {
    PersonalisationServiceListLanderComponentsPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceListLanderComponentsPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceListLanderComponentsPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceListLanderComponentsPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceListLanderComponentsPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceListLanderComponentsPayloadTypeEnum || (PersonalisationServiceListLanderComponentsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderComponentsPayloadCategoryEnum;
(function (PersonalisationServiceListLanderComponentsPayloadCategoryEnum) {
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceListLanderComponentsPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceListLanderComponentsPayloadCategoryEnum || (PersonalisationServiceListLanderComponentsPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum;
(function (PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum) {
    PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum || (PersonalisationServiceListLanderTemplateComponentsPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum;
(function (PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum) {
    PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum || (PersonalisationServiceListLanderTemplateComponentsPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum;
(function (PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum) {
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum || (PersonalisationServiceListLanderTemplateComponentsPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum;
(function (PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum) {
    PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum["IT_UNSPECIFIED"] = "IT_UNSPECIFIED";
    PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum["APPEND"] = "APPEND";
    PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum["PREPEND"] = "PREPEND";
    PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum["REPLACE"] = "REPLACE";
})(PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum || (PersonalisationServiceListPersonalisationsPayloadInsertionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadCampaignPayloadTypeEnum;
(function (PersonalisationServiceReadCampaignPayloadTypeEnum) {
    PersonalisationServiceReadCampaignPayloadTypeEnum["CAMPAIGN_TYPE_NONE"] = "CampaignTypeNone";
    PersonalisationServiceReadCampaignPayloadTypeEnum["CAMPAIGN_TYPE_AB"] = "CampaignTypeAB";
    PersonalisationServiceReadCampaignPayloadTypeEnum["CAMPAIGN_TYPE_SPLIT"] = "CampaignTypeSplit";
})(PersonalisationServiceReadCampaignPayloadTypeEnum || (PersonalisationServiceReadCampaignPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadComponentPayloadUiSourceEnum;
(function (PersonalisationServiceReadComponentPayloadUiSourceEnum) {
    PersonalisationServiceReadComponentPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceReadComponentPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceReadComponentPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceReadComponentPayloadUiSourceEnum || (PersonalisationServiceReadComponentPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadComponentPayloadTypeEnum;
(function (PersonalisationServiceReadComponentPayloadTypeEnum) {
    PersonalisationServiceReadComponentPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceReadComponentPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceReadComponentPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceReadComponentPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceReadComponentPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceReadComponentPayloadTypeEnum || (PersonalisationServiceReadComponentPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadComponentPayloadCategoryEnum;
(function (PersonalisationServiceReadComponentPayloadCategoryEnum) {
    PersonalisationServiceReadComponentPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceReadComponentPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceReadComponentPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceReadComponentPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceReadComponentPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceReadComponentPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceReadComponentPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceReadComponentPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceReadComponentPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceReadComponentPayloadCategoryEnum || (PersonalisationServiceReadComponentPayloadCategoryEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum;
(function (PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum) {
    PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum["IT_UNSPECIFIED"] = "IT_UNSPECIFIED";
    PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum["APPEND"] = "APPEND";
    PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum["PREPEND"] = "PREPEND";
    PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum["REPLACE"] = "REPLACE";
})(PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum || (PersonalisationServiceReadPersonalisationPayloadInsertionTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum;
(function (PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum) {
    PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum["UNSPECIFIED"] = "ComponentUISource_Unspecified";
    PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum["GRAPES"] = "ComponentUISource_grapes";
    PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum["CODE"] = "ComponentUISource_code";
})(PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum || (PersonalisationServiceReadSharedComponentBlockPayloadUiSourceEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum;
(function (PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum) {
    PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum["UNSPECIFIED"] = "ComponentType_Unspecified";
    PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum["LANDING"] = "ComponentType_Landing";
    PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum["LANDING_TEMPLATE"] = "ComponentType_LandingTemplate";
    PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum["LANDING_BLOCK"] = "ComponentType_LandingBlock";
    PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum["LANDING_COMPONENT"] = "ComponentType_LandingComponent";
})(PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum || (PersonalisationServiceReadSharedComponentBlockPayloadTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum;
(function (PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum) {
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["UNSPECIFIED"] = "ComponentBlockCategory_Unspecified";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["STRUCTURAL_LAYOUTS"] = "ComponentBlockCategory_StructuralLayouts";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["HERO_SECTIONS"] = "ComponentBlockCategory_HeroSections";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["PRODUCT_PURCHASE_BLOCK"] = "ComponentBlockCategory_ProductPurchaseBlock";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["PRODUCT_MEDIA"] = "ComponentBlockCategory_ProductMedia";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["FEATURES_AND_BENEFITS"] = "ComponentBlockCategory_FeaturesAndBenefits";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["COMPARISONS"] = "ComponentBlockCategory_Comparisons";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["CTAS"] = "ComponentBlockCategory_CTAs";
    PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum["FAQS"] = "ComponentBlockCategory_FAQs";
})(PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum || (PersonalisationServiceReadSharedComponentBlockPayloadCategoryEnum = {}));
